import React from 'react';
import { useReveal } from '../lib/useReveal';
const ITEMS = [{
  icon: '🌟',
  text: 'Talentos naturales'
}, {
  icon: '❤️',
  text: 'Relaciones y vínculos'
}, {
  icon: '🔥',
  text: 'Desafíos y aprendizajes'
}, {
  icon: '💼',
  text: 'Vocación profesional'
}, {
  icon: '✨',
  text: 'Propósito de vida'
}, {
  icon: '🪐',
  text: 'Influencia de los planetas'
}, {
  icon: '🏠',
  text: 'Áreas de vida representadas por las casas'
}, {
  icon: '🔮',
  text: 'Cartas natales completas'
}];
export function CareerSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#11152e] py-5 md:py-10 px-5 sm:px-6 border-t border-[#ffffff]/5" data-id="element-36">
      <div className="container mx-auto max-w-4xl" data-id="element-37">
        <div ref={ref} className={`reveal ${vis ? 'is-visible' : ''}`} data-id="element-38">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6] text-center mb-6" data-id="element-39">
            ¿Qué podrás interpretar después de completar la formación?
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-40">
            {ITEMS.map((item, i) => <div key={i} className="flex items-center gap-4 bg-[#1a1f3d] border border-[#d4af37]/15 rounded-xl p-5 hover:border-[#d4af37]/40 transition-all" data-id="element-41">
                <span className="text-2xl flex-shrink-0" data-id="element-42">{item.icon}</span>
                <p className="text-[#cbd0e0] text-sm sm:text-base font-medium leading-snug" data-id="element-43">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}